import React from 'react';
import './movingText.scss'
const MovingText = ( ) => {
   const className="MovingText" 
  return (
    <div>
      <div className="bg-blue-600  h-11 overflow-hidden whitespace-nowrap rounded-sm w-64, w-xs, max-w-96">
      
      <div className={className+"__runningTexts flex text-white flex-row overflow-auto gap-4 "}>
        <p className='text-xl font-bold mt-1'>Welcome to TRiANf Learning and Assessment. Break the Mold: Futurize skills. Current rapid developments point to skills set for jobs NOT yet created, but soft skills endure. Facilitating learner to construct their own mental, psycho-muscular and affective knowledge INTENTIONALLY is front and center at TRiANf</p>
        </div>
        
     

    </div>
    </div>
  );
}

export default MovingText;
